import { Image as ImageIcon, Sparkles } from "lucide-react";

/**
 * Cover thumbnail side-panel — preview + "AI cover" generator button.
 */
export default function CoverPanel({ coverUrl, onGenerate, busy }) {
  return (
    <div className="glass rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <ImageIcon size={16} className="text-[#7B2CBF]" />
        <div className="font-display font-bold">Cover thumbnail</div>
      </div>
      {coverUrl ? (
        <img src={coverUrl} alt="cover" className="rounded-xl w-full h-32 object-cover" />
      ) : (
        <div className="rounded-xl w-full h-32 bg-gradient-to-br from-[#7B2CBF]/30 to-[#00E5FF]/20 flex items-center justify-center text-xs text-[#64748B]">
          No cover yet
        </div>
      )}
      <button
        data-testid="ai-cover"
        onClick={onGenerate}
        disabled={busy}
        className="mt-2 nexus-btn-secondary text-xs flex items-center gap-2"
      >
        <Sparkles size={12} /> {busy ? "Manifesting…" : "AI cover"}
      </button>
    </div>
  );
}
